function AITitle() {
    return (
        <div className="AI-title">
            {/* <h1 className="hero-text">Artificial Intelligence</h1> */}
            <h1 className="hero-text">Projects & Researches</h1>
            <h5 className="hero-text">by Reymond Mesuga</h5>
        </div>
    )
}

export default AITitle